import _ from 'lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export default class CaptchaToGenerateTableDto extends IdentifiableDto {
	constructor() {
		super();
        /** @type {number} */
        this.count = null
		/** @type {NamedDto} */
		this.captchaType = null;
	}

	/**
	 * @typedef {Object} _CaptchaToGenerateTableDtoProps
	 * @property {number} count 
	 * @property {NamedDto} captchaType
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaToGenerateTableDtoProps} CaptchaToGenerateTableDtoProps
	 */
	/**
	 *
	 * @param {CaptchaToGenerateTableDtoProps} props
	 * @returns {CaptchaToGenerateTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.count = props.count;
		this.captchaType = props.captchaType !== null ? new NamedDto().setup(props.captchaType) : null;
		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}
